import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Methods from './Methods';
import Form from './Form';
import styles from './modal.module.scss';

class Modal extends Component {
  state = {
    isFormShowing: false,
  };

  showForm = e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({isFormShowing: true});
  };

  render() {
    const {close} = this.props;
    const {isFormShowing} = this.state;

    return (
      <div className={styles.Modal}>
        <div className={classNames(styles.Modal__body, 'bg-party')}>
          <span
            className={classNames(
              'has-text-white is-size-4',
              styles.Modal__close
            )}
            onClick={close}
          >
            &times;
          </span>
          {!isFormShowing ? (
            <div>
              <div className={classNames(styles.Modal__heading)}>
                <h3 className="has-text-white is-size-3">
                  How can we assist you?
                </h3>
                <p className="has-text-white is-size-6">
                  We’re real people who are always happy to help.
                </p>
              </div>
              <Methods showForm={this.showForm} />
            </div>
          ) : (
            <Form />
          )}
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/contact/Modal.js